// NDVIChart.js
import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend);

const NDVIChart = ({ ndviData }) => {
    const data = {
        labels: ndviData.map(d => d.date),
        datasets: [
            {
                label: 'NDVI Value',
                data: ndviData.map(d => d.ndvi),
                fill: false,
                borderColor: 'green',
                tension: 0.3,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
        },
        scales: {
            y: {
                min: 0,
                max: 1,
                title: {
                    display: true,
                    text: 'NDVI',
                },
            },
            x: {
                title: {
                    display: true,
                    text: 'Date',
                },
            },
        },
    };

    return <Line data={data} options={options} />;
};
export default NDVIChart;
